
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'options': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 6.66683C10.9168 6.66683 11.6668 5.91683 11.6668 5.00016C11.6668 4.0835 10.9168 3.3335 10.0002 3.3335C9.0835 3.3335 8.3335 4.0835 8.3335 5.00016C8.3335 5.91683 9.0835 6.66683 10.0002 6.66683ZM10.0002 8.3335C9.0835 8.3335 8.3335 9.0835 8.3335 10.0002C8.3335 10.9168 9.0835 11.6668 10.0002 11.6668C10.9168 11.6668 11.6668 10.9168 11.6668 10.0002C11.6668 9.0835 10.9168 8.3335 10.0002 8.3335ZM8.3335 15.0002C8.3335 14.0835 9.0835 13.3335 10.0002 13.3335C10.9168 13.3335 11.6668 14.0835 11.6668 15.0002C11.6668 15.9168 10.9168 16.6668 10.0002 16.6668C9.0835 16.6668 8.3335 15.9168 8.3335 15.0002Z" fill="#93A0BD"/>'
  }
})
